import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { ThemeProvider } from '@/context/ThemeContext'
import LoginPage from '@/pages/LoginPage'
import GoogleCallbackPage from '@/pages/GoogleCallbackPage'
import MicrosoftCallbackPage from '@/pages/MicrosoftCallbackPage'
import OnboardingPage from '@/pages/OnboardingPage'
import { DashboardPage } from '@/pages/DashboardPage'
import { HealthPage } from '@/pages/HealthPage'
import ChatPage from '@/pages/ChatPage'
import SettingsPage from '@/pages/SettingsPage'
import CalendarPage from '@/pages/CalendarPage'
import SalesPage from '@/pages/SalesPage'
import CampaignDetailPage from '@/pages/CampaignDetailPage'
import SlackCallbackPage from '@/pages/SlackCallbackPage'
import HubSpotCallbackPage from '@/pages/HubSpotCallbackPage'
import ProtectedRoute from '@/components/ProtectedRoute'
import AdminLoginPage from '@/pages/admin/AdminLoginPage'
import AdminDashboardPage from '@/pages/admin/AdminDashboardPage'
import AdminUsersPage from '@/pages/admin/AdminUsersPage'
import AdminWorkspacesPage from '@/pages/admin/AdminWorkspacesPage'
import AdminPlansPage from '@/pages/admin/AdminPlansPage'
import AdminLogsPage from '@/pages/admin/AdminLogsPage'
import AdminAIConfigPage from '@/pages/admin/AdminAIConfigPage'
import AdminProtectedRoute from '@/features/admin/components/AdminProtectedRoute'
import { Toaster } from '@/components/ui/toaster'
import { NotificationsProvider } from '@/context/NotificationsContext'
import './index.css'

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/health" element={<HealthPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/login/google/callback" element={<GoogleCallbackPage />} />
          <Route path="/login/microsoft/callback" element={<MicrosoftCallbackPage />} />
          <Route path="/onboarding" element={<OnboardingPage />} />
          <Route path="/dashboard" element={<ProtectedRoute><NotificationsProvider><DashboardPage /></NotificationsProvider></ProtectedRoute>} />
          <Route path="/dashboard/chat" element={<ProtectedRoute><NotificationsProvider><ChatPage /></NotificationsProvider></ProtectedRoute>} />
          <Route path="/dashboard/settings" element={<ProtectedRoute><NotificationsProvider><SettingsPage /></NotificationsProvider></ProtectedRoute>} />
          {/* Prospects moved under Sales; kept so existing links and push notifications still land. */}
          <Route path="/dashboard/prospects" element={<Navigate to="/dashboard/sales?tab=prospects" replace />} />
          <Route path="/dashboard/calendar" element={<ProtectedRoute><NotificationsProvider><CalendarPage /></NotificationsProvider></ProtectedRoute>} />
          <Route path="/dashboard/sales" element={<ProtectedRoute><NotificationsProvider><SalesPage /></NotificationsProvider></ProtectedRoute>} />
          <Route path="/dashboard/campaigns/:campaignId" element={<ProtectedRoute><NotificationsProvider><CampaignDetailPage /></NotificationsProvider></ProtectedRoute>} />
          {/* Now a Settings tab — redirect the old standalone URL rather than 404 for anyone with it bookmarked */}
          <Route path="/dashboard/company-profile" element={<Navigate to="/dashboard/settings?tab=company-profile" replace />} />
          <Route path="/dashboard/knowledge-base" element={<Navigate to="/dashboard/settings?tab=company-profile" replace />} />
          <Route path="/oauth/slack/callback" element={<SlackCallbackPage />} />
          <Route path="/oauth/hubspot/callback" element={<HubSpotCallbackPage />} />

          {/* Admin routes */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<AdminProtectedRoute><AdminDashboardPage /></AdminProtectedRoute>} />
          <Route path="/admin/users" element={<AdminProtectedRoute><AdminUsersPage /></AdminProtectedRoute>} />
          <Route path="/admin/workspaces" element={<AdminProtectedRoute><AdminWorkspacesPage /></AdminProtectedRoute>} />
          <Route path="/admin/plans" element={<AdminProtectedRoute><AdminPlansPage /></AdminProtectedRoute>} />
          <Route path="/admin/logs" element={<AdminProtectedRoute><AdminLogsPage /></AdminProtectedRoute>} />
          <Route path="/admin/ai-config" element={<AdminProtectedRoute><AdminAIConfigPage /></AdminProtectedRoute>} />
          <Route path="/admin/*" element={<Navigate to="/admin" replace />} />

          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </ThemeProvider>
  )
}

export default App
